module.exports = __webpack_public_path__ + "static/img/account.bf66028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/account.png
// module id = 18
// module chunks = 1 2 3 5 6 7 8 9